<template>
    <div class="row">
        <div class="col-lg-8">
            <div class="card card-body">
                <div class="d-flex justify-content-between">
                    <div class="mb-3 d-flex justify-content-center">
                        <div class="custom-control custom-radio custom-control-inline mr-3">
                            <input type="radio" class="custom-control-input pl-4" name="workplace" id="rdo-workplace-office" v-model="calendar_filter.workplace" value="office">
                            <label class="custom-control-label" for="rdo-workplace-office">Kontor</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline mr-3">
                            <input type="radio" class="custom-control-input pl-4" name="workplace" id="rdo-workplace-warehouse" v-model="calendar_filter.workplace" value="warehouse">
                            <label class="custom-control-label" for="rdo-workplace-warehouse">Lager</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline mr-3">
                            <input type="radio" class="custom-control-input pl-4" name="workplace" id="rdo-workplace-store" v-model="calendar_filter.workplace" value="store">
                            <label class="custom-control-label" for="rdo-workplace-store">Butik</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline mr-3">
                            <input type="radio" class="custom-control-input pl-4" name="workplace" id="rdo-workplace-all" v-model="calendar_filter.workplace" value="">
                            <label class="custom-control-label" for="rdo-workplace-all">Alla</label>
                        </div>
                    </div>
                    <div style="width: 250px;">
                        <user-filter
                            :reduce="(opt) => opt.id"
                            v-model="calendar_filter.user_id"
                            placeholder="-- Alla anställda --"
                        ></user-filter>
                    </div>
                </div>
                <FullCalendar
                    ref="calendar"
                    class='demo-app-calendar'
                    :options='calendar_options'
                >
                    <template v-slot:eventContent='arg'>
                        <div v-if="arg.event.extendedProps.time_str">{{ arg.event.extendedProps.time_str }}</div>
                        <div style="white-space: normal;">
                            <span>{{ arg.event.title }}</span>
                            <span v-if="arg.event.extendedProps.people">({{ arg.event.extendedProps.people }})</span>
                        </div>
                    </template>
                </FullCalendar>
            </div>

            <div id="modal_event" class="modal fade">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title"><i class="icon-calendar22 mr-2"></i>Kalenderbokning</h5>
                            <button type="button" class="close" data-dismiss="modal">&times;</button>
                        </div>
                        <div class="modal-body" v-if="event">
                            <form @submit.prevent="saveEvent">
                                <ValidationObserver ref="eventform">
                                    <div class="row">
                                        <label class="col-form-label col-lg-2">Start: <span class="text-danger">*</span></label>
                                        <div class="col-lg-4">
                                            <ValidationProvider vid="start_date" name="Start" rules="required" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <v-date-picker v-model="event.start_date" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }">
                                                        <template v-slot="{ inputValue, togglePopover }">
                                                            <input class="form-control" :value="inputValue" @focus="togglePopover()">
                                                        </template>
                                                    </v-date-picker>
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-lg-3">
                                            <ValidationProvider vid="start_time" name="Start" rules="required" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <input type="time" class="form-control" v-model="event.start_time" :disabled="event_all_day" v-bind:class="{ 'border-danger':errors[0] }">
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-lg-3">
                                            <div class="form-check">
                                                <label class="form-check-label" style="padding-top: 8px;">
                                                    <input type="checkbox" class="form-check-input" v-model="event_all_day">
                                                    Hela dagen
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <label class="col-form-label col-lg-2">Slut: <span class="text-danger">*</span></label>
                                        <div class="col-lg-4">
                                            <ValidationProvider vid="end_date" name="Slut" rules="required" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <v-date-picker v-model="event.end_date" mode="date" :model-config="{ type: 'string', mask: 'YYYY-MM-DD' }" :masks="{ input: 'YYYY-MM-DD' }">
                                                        <template v-slot="{ inputValue, togglePopover }">
                                                            <input class="form-control" :value="inputValue" @focus="togglePopover()">
                                                        </template>
                                                    </v-date-picker>
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-lg-3">
                                            <ValidationProvider vid="end_time" name="Slut" rules="required" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <input type="time" class="form-control" v-model="event.end_time" :disabled="event_rest_of_day||event_all_day" v-bind:class="{ 'border-danger':errors[0] }">
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                        <div class="col-lg-3">
                                            <div class="form-check">
                                                <label class="form-check-label" style="padding-top: 8px;">
                                                    <input type="checkbox" class="form-check-input" v-model="event_rest_of_day">
                                                    Resten av dagen
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <label class="col-form-label col-lg-2">Typ: <span class="text-danger">*</span></label>
                                        <div class="col-lg-10">
                                            <ValidationProvider vid="TypeID" name="Typ" rules="required" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <v-select
                                                        v-model="event.TypeID"
                                                        :options="calendar_types"
                                                        label="BookingType"
                                                        :reduce="item => item.TypeID"
                                                        :class="{'has-validation-error':(!!errors[0])}"
                                                        placeholder="Välj..."
                                                    />
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <label class="col-form-label col-lg-2">Deltagare: <span class="text-danger">*</span></label>
                                        <div class="col-lg-10">
                                            <ValidationProvider vid="people_ids" name="Deltagare" rules="required" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <user-filter
                                                        v-model="event.people_ids"
                                                        :reduce="item => item.id"
                                                        placeholder="Välj..."
                                                        multiple
                                                        :class="{'has-validation-error':(!!errors[0])}"
                                                    ></user-filter>
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <label class="col-form-label col-lg-2">Rubrik:</label>
                                        <div class="col-lg-10">
                                            <ValidationProvider vid="ItemHeader" name="Rubrik" rules="" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <input type="text" class="form-control" v-model="event.ItemHeader" v-bind:class="{ 'border-danger':errors[0] }">
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>

                                    <div class="row">
                                        <label class="col-form-label col-lg-2">Beskrivning:</label>
                                        <div class="col-lg-10">
                                            <ValidationProvider vid="ItemDesc" name="Beskrivning" rules="" v-slot="{ errors }">
                                                <div class="form-group">
                                                    <textarea rows="5" class="form-control" v-model="event.ItemDesc" v-bind:class="{ 'border-danger':errors[0] }"></textarea>
                                                    <span class="validation-invalid-label">{{ errors[0] }}</span>
                                                </div>
                                            </ValidationProvider>
                                        </div>
                                    </div>
                                </ValidationObserver>
                            </form>
                            <div v-if="event.created_at" class="text-muted">Skapad: {{ formatDateTime(event.created_at) }}{{ (event.created_by_user ?  ' / ' + event.created_by_user.FullName : '') }}</div>
                            <div v-if="event.updated_at" class="text-muted">Ändrad: {{ formatDateTime(event.updated_at) }}{{ (event.updated_by_user ?  ' / ' + event.updated_by_user.FullName : '') }}</div>
                        </div>
                        <div class="modal-body" v-else>
                            <i style="color:red;">Kunde ej ladda event</i>
                        </div>
                        <div class="modal-footer">
                            <limitless-button ref="btndeleteevent" type="button" @click="deleteEvent" :busy="event_busy_saving" class="mr-auto" btn-class="btn-danger" icon="icon-trash">RADERA</limitless-button>
                            <button type="button" class="btn btn-light" data-dismiss="modal">Stäng</button>
                            <limitless-button ref="btnsaveevent" type="button" @click="saveEvent" :busy="event_busy_saving" icon="icon-floppy-disk">SPARA</limitless-button>
                        </div>
                    </div>
                </div>
            </div> <!-- /modal -->
        </div>
        <div class="col-lg-4" v-if="quickmessage">
            <div class="card">
                <div class="card-header bg-light">
                    <h6 class="card-title"><i class="icon-info22 position-left"></i> <span class="text-semibold">Information</span></h6>
                </div>
                <div class="card-body">
                    <form @submit.prevent="saveQuckMessage">
                        <div class="form-group">
                            <textarea class="form-control" rows="27" v-model="quickmessage.Message"></textarea>
                            <div style="color:#bbb; font-style: italic; font-size: 10px;">{{ formatDateTime(quickmessage.CreatedTS) }}<span v-if="quickmessage.user"> // {{ quickmessage.user.name }}</span></div>
                        </div>
                        <limitless-button ref="btnsavequickmessage" type="submit" :busy="quickmessage_busy_saving" icon="icon-floppy-disk">SPARA</limitless-button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FullCalendar from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import svLocale from '@fullcalendar/core/locales/sv';
import apiClient from '@services/ApiClient';
import LimitlessButton from '@components/Limitless/LimitlessButton';
import vSelect from 'vue-select';
import VDatePicker from 'v-calendar/lib/components/date-picker.umd';
import { formatDateTime } from '@services/Helpers';
import getError from '@services/ErrorHelper';
import { mapState } from 'pinia';
import UserFilter from '@components/Filters/UserFilter.vue';
import BackendRepository from '@services/repositories/BackendRepository';
import { useAuthStore } from '@services/pinia/AuthStore';

export default {
    name: 'DashboardCalendar',
    components: {
        UserFilter,
        FullCalendar,
        LimitlessButton,
        vSelect,
        VDatePicker,
    },
    data() {
        return {
            calendar_filter: {
                workplace: 'office',
                user_id: null,
            },
            current_events: [],
            event_busy_saving: false,
            event: null,
            event_rest_of_day: false,
            event_all_day: false,
            quickmessage_busy_saving: false,
            quickmessage: null,
            calendar_types: [],
        };
    },
    watch: {
        event_all_day(val) {
            if (val) {
                this.event.start_time = '00:00';
                this.event.end_time = '23:59';
                this.event_rest_of_day = false;
            }
        },
        event_rest_of_day(val) {
            if (val) {
                this.event.end_time = '23:59';
                this.event_all_day = false;
            }
        },
    },
    mounted() {
        this.getQuckMessage();
        this.getCalendarTypes();
        if (this.user.workplace_type) {
            this.calendar_filter.workplace = this.user.workplace_type;
        }
    },
    methods: {
        formatDateTime,
        handleWeekendsToggle() {
            this.calendarOptions.weekends = !this.calendarOptions.weekends; // update a property
        },
        handleDateSelect(selectInfo) {
            this.openEventModal(0, selectInfo.startStr);
        },
        handleEventClick(clickInfo) {
            this.openEventModal(clickInfo.event.id);
        },
        // handleEvents(events) {
        //     this.current_events = events
        // },
        openEventModal(eventId, date = '') {
            const vm = this;
            apiClient.get(`/vue/dashboard/calendar/${eventId}?start_date=${date}`)
                .then((response) => {
                    vm.event = response.data;
                    if (response.data.start_time === '00:00' && response.data.end_time === '23:59') {
                        vm.event_all_day = true;
                        vm.event_rest_of_day = false;
                    } else if (response.data.end_time === '23:59') {
                        vm.event_all_day = false;
                        vm.event_rest_of_day = true;
                    } else {
                        vm.event_all_day = false;
                        vm.event_rest_of_day = false;
                    }
                    // eslint-disable-next-line no-undef
                    $('#modal_event').modal('show');
                });
        },
        async saveEvent() {
            const vm = this;
            // vm.$refs.btnsaveevent.triggerFailed()
            const isValid = await vm.$refs.eventform.validate();
            if (isValid) {
                vm.event_busy_saving = true;
                await apiClient.post(`/vue/dashboard/calendar/${vm.event.ItemID}`, vm.event)
                    .then((response) => {
                        vm.todo = response.data;
                        vm.$refs.btnsaveevent.triggerSaved();
                        const calendarApi = vm.$refs.calendar.getApi();
                        calendarApi.refetchEvents();
                        // eslint-disable-next-line no-undef
                        $('#modal_event').modal('hide');
                    })
                    .catch((error) => {
                        const parsederror = getError(error);
                        if (typeof parsederror === 'object') {
                            vm.$refs.eventform.setErrors(parsederror);
                        }
                        vm.$refs.btnsaveevent.triggerFailed();
                    })
                    .finally(() => {
                        vm.event_busy_saving = false;
                    });
            } else {
                vm.$refs.btnsaveevent.triggerFailed();
            }
        },
        async deleteEvent() {
            const vm = this;
            // eslint-disable-next-line no-undef
            this.$swal({
                icon: 'warning',
                title: 'Vill du verkligen radera?',
                showCancelButton: true,
                confirmButtonText: 'Ja, radera',
                cancelButtonText: 'Avbryt',
            }).then(async (result) => {
                if (result.value) {
                    vm.event_busy_saving = true;
                    await apiClient.delete(`/vue/dashboard/calendar/${vm.event.ItemID}`)
                        .then(() => {
                            vm.$refs.btndeleteevent.triggerSaved();
                            const calendarApi = vm.$refs.calendar.getApi();
                            calendarApi.refetchEvents();
                            // eslint-disable-next-line no-undef
                            $('#modal_event').modal('hide');
                        })
                        .catch(() => {
                            vm.$refs.btndeleteevent.triggerFailed();
                        })
                        .finally(() => {
                            vm.event_busy_saving = false;
                        });
                }
            });
        },
        async getQuckMessage() {
            const vm = this;
            await apiClient.get('/vue/dashboard/quickmessage/0?latest=1')
                .then((response) => {
                    vm.quickmessage = response.data;
                });
        },
        async saveQuckMessage() {
            const vm = this;
            vm.quickmessage_busy_saving = true;
            await apiClient.post('/vue/dashboard/quickmessage', vm.quickmessage)
                .then((response) => {
                    vm.quickmessage = response.data;
                    vm.$refs.btnsavequickmessage.triggerSaved();
                })
                .catch(() => {
                    vm.$refs.btnsavequickmessage.triggerFailed();
                })
                .finally(() => {
                    vm.quickmessage_busy_saving = false;
                });
        },
        getCalendarTypes() {
            BackendRepository.getCalendarTypes().then((res) => {
                this.calendar_types = res;
            });
        },
    },
    computed: {
        ...mapState(useAuthStore, ['user']),
        calendar_options() {
            return {
                locale: svLocale,
                weekNumbers: true,
                firstDay: 1,
                height: 'auto',
                plugins: [
                    dayGridPlugin,
                    interactionPlugin, // needed for dateClick
                ],
                views: {
                    dayGridThreeWeeks: {
                        type: 'dayGrid',
                        duration: { weeks: 3 },
                    },
                },
                headerToolbar: {
                    left: 'prev',
                    center: 'title',
                    right: 'today next',
                    // right: 'dayGridMonth,timeGridWeek,timeGridDay'
                },
                initialView: 'dayGridThreeWeeks',
                eventSources: [
                    {
                        url: '/vue/dashboard/calendar',
                        // eslint-disable-next-line no-unused-vars
                        extraParams: Object.fromEntries(Object.entries(this.calendar_filter).filter(([_, v]) => v != null && v !== '')),
                    },
                ],
                editable: true,
                selectable: true,
                selectMirror: true,
                dayMaxEvents: true,
                weekends: true,
                select: this.handleDateSelect,
                eventClick: this.handleEventClick,
                // eventsSet: this.handleEvents
                /* you can update a remote database when these fire:
                eventAdd:
                eventChange:
                eventRemove:
                */
            };
        },
    },
};
</script>
<style>
.fc-scrollgrid-sync-table .fc-daygrid-day-frame {
    height: 100%;
    min-height: 180px;
}
.fc-bg-event > span > div > span {
    padding: 4px;
    color: #000;
    display: block;
}
.fc-bg-event {
    border: none;
    border-radius: 0;
}
.fc-day-sun {
    background-color: #ffeeee;
}
.fc-day-sun .fc-bg-event {
    background-color: transparent !important;
}
.fc-day-mon .fc-bg-event > span > div > span {
    padding-left: 32px !important;
}
</style>
